/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";

import Modal from "../components/Modal";

import { useModalStore } from "../stores/hooks";

function ConfirmReceiverAddressModal({ delivery, onConfirm }) {
  const { closeModal } = useModalStore();

  const handleSubmit = () => {
    closeModal();
    if (onConfirm) {
      onConfirm();
    }
  };

  return (
    <Modal>
      <div className="">
        <div className="pt-20 px-15 mb-20">
          <h5 className="text-18 font-bold text-center mb-15">주소지 재확인</h5>

          {/* 도로명주소 (도착지 정보 렌더링 블록과 동일 조합식) */}
          <div className="text-18 mb-10">
            {delivery.receiverAddressRoadWithoutSigungu ||
              delivery.receiverAddressWithoutSigungu ||
              ""}{" "}
            {delivery.receiverBuilding}
            {delivery.receiverAddressRoadWithoutSigungu &&
            delivery.receiverAddressWithoutSigungu
              ? `/${delivery.receiverAddressWithoutSigungu}`
              : ""}
            {!delivery.receiverAddressRoadWithoutSigungu && delivery.receiverDong
              ? `/${delivery.receiverDong}`
              : ""}
          </div>

          {/* 동/호수 (큰 글씨) */}
          <div className="text-24 font-bold mb-10">
            {delivery.receiverBuildingDongNumber ||
            delivery.receiverBuildingHouseNumber
              ? delivery.receiverBuildingDongHouseNumber
              : "동/호 없음"}
          </div>

          {/* 고객요청 memo */}
          <div className="text-18 mb-10">[요청주의] {delivery.memo || "없음"}</div>

          {/* 지번주소 */}
          <div className="text-18">{delivery.displayAddress}</div>
        </div>
        <div className="flex justify-end items-center border-t-1 border-gray-8">
          <button
            type="button"
            className="text-16 flex-1 p-10"
            onClick={handleSubmit}
          >
            확인
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default ConfirmReceiverAddressModal;
